module.exports = __webpack_public_path__ + "img/riders_stub.98aa887d.png";